import { lazy, type ReactElement } from "react";
import type { GuideExampleKind } from "@/help/guides/types";
const PayrollFlow = lazy(() =>
  import("./payroll/payroll-flow-example").then((module) => ({
    default: module.PayrollFlowExample,
  })),
);
const PayrollExport = lazy(() =>
  import("./payroll/payroll-export-example").then((module) => ({
    default: module.PayrollExportExample,
  })),
);
const Roster = lazy(() =>
  import("./payroll/roster-example").then((module) => ({
    default: module.RosterExample,
  })),
);
const PeriodRoster = lazy(() =>
  import("./payroll/period-roster-example").then((module) => ({
    default: module.PeriodRosterExample,
  })),
);
const PayPlan = lazy(() =>
  import("./payroll/pay-plan-example").then((module) => ({
    default: module.PayPlanExample,
  })),
);
const Grid = lazy(() =>
  import("./practice-grid").then((module) => ({
    default: module.PracticeGrid,
  })),
);
const Statement = lazy(() =>
  import("./paypacks/statement-example").then((module) => ({
    default: module.StatementExample,
  })),
);
const SendPacks = lazy(() =>
  import("./paypacks/paypack-send-example").then((module) => ({
    default: module.PaypackSendExample,
  })),
);
const Delivery = lazy(() =>
  import("./paypacks/delivery-example").then((module) => ({
    default: module.DeliveryExample,
  })),
);
const Pushpay = lazy(() =>
  import("./pushpay-example").then((module) => ({
    default: module.PushpayExample,
  })),
);
const Email = lazy(() =>
  import("./accounts-payable/email-example").then((module) => ({
    default: module.EmailExample,
  })),
);
const Vendor = lazy(() =>
  import("./accounts-payable/vendor-example").then((module) => ({
    default: module.VendorExample,
  })),
);
const Invoices = lazy(() =>
  import("./accounts-payable/invoice-list-example").then((module) => ({
    default: module.InvoiceListExample,
  })),
);
const Upload = lazy(() =>
  import("./accounts-payable/upload-example").then((module) => ({
    default: module.UploadExample,
  })),
);
const InvoiceDocument = lazy(() =>
  import("./accounts-payable/invoice-document-example").then((module) => ({
    default: module.InvoiceDocumentExample,
  })),
);
const Matching = lazy(() =>
  import("./accounts-payable/matching-example").then((module) => ({
    default: module.MatchingExample,
  })),
);
const LineItems = lazy(() =>
  import("./accounts-payable/line-items-example").then((module) => ({
    default: module.LineItemsExample,
  })),
);
const Action = lazy(() =>
  import("./accounts-payable/action-example").then((module) => ({
    default: module.ActionExample,
  })),
);
const CreateUser = lazy(() =>
  import("./settings/create-user-example").then((module) => ({
    default: module.CreateUserExample,
  })),
);

export const EXAMPLES: Record<GuideExampleKind, ReactElement> = {
  "payroll-run": <PayrollFlow />,
  "payroll-review": <Grid />,
  "payroll-export": <PayrollExport />,
  roster: <Roster />,
  "period-roster": <PeriodRoster />,
  "pay-plan": <PayPlan />,
  statement: <Statement />,
  "send-packs": <SendPacks />,
  delivery: <Delivery />,
  packchat: <Statement chat />,
  "pushpay-review": <Pushpay reviewOnly />,
  "pushpay-send": <Pushpay />,
  invoices: <Invoices />,
  upload: <Upload />,
  "invoice-details": <InvoiceDocument />,
  review: <Invoices review />,
  matching: <Matching />,
  "line-items": <LineItems />,
  actions: <Action />,
  automated: <Action automated />,
  emails: <Email />,
  vendors: <Vendor />,
  "create-user": <CreateUser />,
};
